"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const List_1 = __importDefault(require("@material-ui/core/List"));
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const changeSidePanel_1 = require("../../actions/app/changeSidePanel");
const service_1 = __importDefault(require("../../services/userMgmt/service"));
const users_1 = require("../../domain/model/users");
const gotoUser_1 = __importDefault(require("../../actions/chats/gotoUser"));
const SearchBox_1 = __importDefault(require("../shared/SearchBox"));
const UserListItem_1 = __importDefault(require("../shared/UserListItem"));
const Header_1 = __importDefault(require("./Header"));
const CloseButton_1 = __importDefault(require("../shared/CloseButton"));
const CreateGroupChatIcon_1 = __importDefault(require("../shared/CreateGroupChatIcon"));
const panels_1 = require("../../domain/model/panels");
const PLACEHOLDER_TEXT = "Type a username";
exports.default = react_1.default.memo(NewDirectChatPanel);
const useStyles = makeStyles_1.default((theme) => ({
    closeButton: {
        color: colorManipulator_1.alpha(theme.colors.header.primaryTextColor, 0.6)
    }
}));
function NewDirectChatPanel() {
    const dispatch = react_redux_1.useDispatch();
    const classes = useStyles();
    const emptyResults = [];
    const [text, setText] = react_1.useState("");
    const [results, setResults] = react_1.useState(emptyResults);
    const clearInput = () => setText("");
    const textBoxRef = react_1.useRef(null);
    function handleInputChange(text) {
        setText(text);
        if (text.length > 0) {
            const request = {
                search_term: text,
                max_results: 20
            };
            service_1.default.searchUsers(request).then(response => {
                setResults(response.users);
            });
        }
        else {
            setResults(emptyResults);
        }
    }
    function closePanel() {
        clearInput();
        dispatch(changeSidePanel_1.changeLeftPanel(panels_1.LeftPanelType.Chats));
    }
    function handleSelectUser(user) {
        closePanel();
        dispatch(gotoUser_1.default(user));
    }
    react_1.useLayoutEffect(() => {
        var _a;
        (_a = textBoxRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Header_1.default, { leftIcon: react_1.default.createElement(CreateGroupChatIcon_1.default, { size: "sm" }), title: "Start a new chat", rightIcon: react_1.default.createElement(CloseButton_1.default, { onClick: closePanel, className: classes.closeButton }) }),
        react_1.default.createElement(SearchBox_1.default, { text: text, onChange: handleInputChange, placeholderText: PLACEHOLDER_TEXT, ref: textBoxRef }),
        react_1.default.createElement(List_1.default, { disablePadding: true }, results.map(user => react_1.default.createElement(UserListItem_1.default, { key: user.userId, user: users_1.fromUserSummary(user), handleSelectUser: () => handleSelectUser(user) })))));
}
